import axios from '../config/axios';
import { getToken } from './tokenStore';

const API_URL = `${(
  process.env.REACT_APP_API_URL ||
  'https://backend-clinical-intake.dizzaroo.com'
).replace(/\/$/, '')}/api`;

const administrativeInfoService = {
  // Create new administrative information
  createAdministrativeInfo: async (data) => {
    try {
      const token = getToken();
      const response = await axios.post(`${API_URL}/administrative-info`, data, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all administrative information (optionally filtered by projectId)
  getAllAdministrativeInfo: async (projectId) => {
    try {
      const token = getToken();
      const params = {};
      if (projectId) params.projectId = projectId;
      const response = await axios.get(`${API_URL}/administrative-info`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get latest administrative information for a project
  getLatestAdministrativeInfo: async (projectId) => {
    try {
      const token = getToken();
      const response = await axios.get(`${API_URL}/administrative-info/latest`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: { projectId }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get administrative information by ID
  getAdministrativeInfoById: async (id) => {
    try {
      const token = getToken();
      const response = await axios.get(`${API_URL}/administrative-info/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update administrative information
  updateAdministrativeInfo: async (id, data) => {
    try {
      const token = getToken();
      const response = await axios.put(`${API_URL}/administrative-info/${id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete administrative information
  deleteAdministrativeInfo: async (id) => {
    try {
      const token = getToken();
      const response = await axios.delete(`${API_URL}/administrative-info/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default administrativeInfoService; 